export const combatIntroTitle =
  'Do you want to answer the optional questions about behavorial changes?';

export const combatIntroDescription =
  'We’ll now ask you a few questions about the behavioral changes you experienced after combat events. You can choose to answer these questions or skip them. If we need more information, we’ll contact you.';

export const answerCombatQuestionsChoice =
  'Yes, I want to answer these questions.';
export const optOutOfCombatQuestionsChoice =
  'No, I want to skip these questions.';

export const deleteCombatAnswersModalTitle =
  'Skip questions about behavioral changes instead?';

export const missingSelectionErrorMessage =
  'A response is needed for this question. If you don’t wish to answer optional questions about behavioral changes, you may select ‘no’ and continue.';
